import React from "react";
import { Container } from "reactstrap";
import FloorEditor from "./FloorEditor";

// Pagina Sala e tavoli (voce della sidebar sotto Bookings).
const TablesPage = () => (
  <div className="content">
    <Container fluid>
      <FloorEditor />
    </Container>
  </div>
);

export default TablesPage;
